export default [
    {
        title: '序号',
        type: 'number',
        dataIndex: 'id',
        key: 'id',
        width: '8%',
        sorter: (a, b) => a.id - b.id,
        // editable: true,
    },
    {
        title: '手机号',
        type: 'string',
        dataIndex: 'phone',
        key: 'phone',
        width: '12%',
        sorter: (a, b) => Number(a.phone) - Number(b.phone),
        editable: true,
    },
    {
        title: '已注册',
        type: 'boolean',
        dataIndex: 'isMember',
        key: 'isMember',
        width: '9%',
        render: (text) => text ? text.toString() : 'false',
        sorter: (a, b) => Number(b.isMember) - Number(a.isMember),
        editable: true,
    },
    {
        title: '密码',
        type: 'string',
        dataIndex: 'password',
        key: 'password',
        width: '10%',
        editable: true,
    },
    {
        title: '用户名',
        type: 'string',
        dataIndex: 'userName',
        key: 'userName',
        width: '12%',
        editable: true,
    },
    {
        title: '备注',
        type: 'string',
        dataIndex: 'setName',
        key: 'setName',
        width: '12%',
        editable: true,
    },
    {
        title: '平台',
        type: 'string',
        dataIndex: 'platform',
        key: 'platform',
        width: '10%',
        editable: true,
    },
    {
        title: '短信接收',
        type: 'string',
        dataIndex: 'msgType',
        key: 'msgType',
        width: '10%',
        editable: true,
    },
];